import { type AppThunk } from "../../../index";
import { unsubscribeFromProductDetails as actionCreator } from "../reducer";
import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromProductDetails =
  (): AppThunk =>
  async (dispatch, getState, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "product");

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeProductListChannel;
    subscriptions.realtimeProductListChannel = null;
    // was clearing productsListChannelName - that one belongs to the products list
    subscriptions.productListChannelName = null;
    void closeRealtimeChannel(db, channel);
    dispatch(actionCreator());
  };
